import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Button } from "../core/components/button";
import { FAIcon } from "../core/components/faIcon";
import { TabStrip, TabStripProps } from "../core/components/tabStrip";
import React from "react";
export default class ServiceReportAccountAssignmentTab extends React.Component<any, any> {
    private tabStripMetadata: TabStripProps = {
        dataSources: {},
        metadata: {
            tabs: [
                {
                    title: this.props.translations["WebSMS.ServiceReport.KontierungGesamt"],
                    component: "renderGridAccountAssignmentTotal"
                },
                {
                    title: this.props.translations["WebSMS.ServiceReport.KontierungProTag"],
                    component: "renderGridAccountAssignmentPerDay"
                }
            ],
            additional: {
                objects: []
            }
        },
        onChange: (field: { model: string }, value: any, dataItem?: any) => {
        },
        handleEval: (expression: string) => {
            if (expression === "renderGridAccountAssignmentTotal")
                return this.renderGridAccountAssignmentTotal();
            else if (expression == "renderGridAccountAssignmentPerDay")
                return this.renderGridAccountAssignmentPerDay();
        },
        entity: {
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            }
        },
        commandManager: this.props.commandManager,
        horizontal: true
    };

    reloadAccountAssignment = () => {
        var entity = this.props.entity;
        HTTPService.get<JsonResultClass>("ServiceReport/Init/?projNr=" + encodeURIComponent(entity.Projnr) + '&pIndex=' + encodeURIComponent(entity.Pindex) + '&id=' + encodeURIComponent(entity.Belegnr))
            .then((data) => {
                this.props.onChange({ model: "entity.Autokontierung" }, data.Data.Autokontierung);
                this.props.onChange({ model: "entity.AccountAssignmentTotal" }, data.Data.AccountAssignmentTotal);
                this.props.onChange({ model: "entity.AccountAssignmentPerDay" }, data.Data.AccountAssignmentPerDay);
                this.props.context.onHandlePostSave(true);
            });
    }

    renderGridAccountAssignmentTotal = () => {
        return (
            <Grid
                id="serviceReportAccountAssignmentTotal"
                data={this.props.entity.AccountAssignmentTotal}
                options={this.props.context.references.accountAssignmentTotalGridOptions}>
            </Grid>
        );
    }

    renderGridAccountAssignmentPerDay = () => {
        return (
            <Grid
                id="serviceReportAccountAssignmentPerDay"
                data={this.props.entity.AccountAssignmentPerDay}
                options={this.props.context.references.accountAssignmentPerDayGridOptions}>
            </Grid>
        );
    }

    render() {
        return (
            <div className="flex-container">
                <div style={{margin: "5px"}}>
                    {
                        this.props.entity.Autokontierung == 1 ?
                            <div className="flex-container" style={{flexDirection: "row"}}>
                                <FAIcon name="hourglass" wrapperToolTip={this.props.translations["WebSMS.ServiceReport.AutoKontierungLaeuft"]} style={{ color: "green", fontSize: "xx-large" }} />
                                <Button iconName="undo" title={this.props.translations["Standard.Aktualisieren"]} handleClick={this.reloadAccountAssignment} readOnly={this.props.context.onEvalAction("saveEnabled")} /> 
                            </div>: null
                    }
                    {
                        this.props.entity.Autokontierung == 2 ?
                            <FAIcon name="check-circle" wrapperToolTip={this.props.translations["WebSMS.ServiceReport.AutoKontierungErfolgreich"]} style={{ color: "green", fontSize: "xx-large" }} /> : null
                    }
                    {
                        this.props.entity.Autokontierung == 3 ?
                            <FAIcon name="exclamation-circle" wrapperToolTip={this.props.translations["WebSMS.ServiceReport.AutoKontierungFehler"]} style={{ color: "red", fontSize: "xx-large" }} /> : null
                    }
                </div>
                <TabStrip {...this.tabStripMetadata} />
            </div>
        );
    };
}